<div class="container-fluid">
    <div class="row table-header fw-bold py-2 mt-2">
        <div class="col-1"></div>
        @for (column of tableModel.options.columns; track column) {
            <div class="col-lg-3 col-5">{{ column.title }}</div>
        }
    </div>
    @for (row of tableModel.rows; track row; let i = $index) {
        <pace-pi-measurement-tools-expandable
            [parentForm]="formChildren"
            [row]="row"
            [columns]="tableModel.options.columns"
            (deleteRow)="deleteMeasurementTool(i)"
            (updateRow)="validateMeasurementTool(i, $event)"
        >
        </pace-pi-measurement-tools-expandable>
    }
</div>

<div class="row mt-3">
    <div class="col-12">
        <button
            class="btn btn-primary float-end"
            type="button"
            [translate]="'PHYSICAL_INVENTORY_ADD_NEW_ENTRY_LABEL'"
            (click)="addMeasurementTool()"
        ></button>
    </div>
</div>
